let configureStore;
let history;

if (process.env.NODE_ENV === 'production') {
  const prod = require('./store.prod');
  configureStore = prod.default;
  history = prod.history;
} else {
  const dev = require('./store.dev');
  configureStore = dev.default;
  history = dev.history;
}

const store = configureStore();

export { history };
export default store;
